import React from "react";
import Container from "./container";
import { cn } from "../lib/helpers";
import ImageG from "./image-g";
import Video from "./video";
import Button from "./button";
import PortableText from "./portableText";

import * as styles from "../styles/components/fc-two-up-media.module.css";

interface MediaAsset {
  asset?: {
    _id?: string;
    url?: string;
    originalFilename?: string;
  };
  alt?: string;
}

interface MediaImage {
  desktop?: MediaAsset;
  mobile?: MediaAsset;
}

interface MediaVideo {
  mp4?: MediaAsset;
  webm?: MediaAsset;
}

interface Media {
  image?: MediaImage;
  video?: MediaVideo;
}

interface ButtonType {
  blank?: boolean;
  text?: string;
  url?: string;
}

interface TwoUpMediaProps {
  mediaLarge?: Media;
  mediaSmall?: Media;
  title?: string;
  _rawCopy?: any[];
  button?: ButtonType;
  switchSide?: boolean;
  textPositionTop?: boolean;
}

const TwoUpMedia: React.FC<TwoUpMediaProps> = ({
  mediaLarge,
  mediaSmall,
  title,
  _rawCopy,
  button,
  switchSide,
  textPositionTop
}) => {
  // Provide a default empty object for media if it's not passed
  const { image: imageL, video: videoL } = mediaLarge || {};
  const { image: imageS, video: videoS } = mediaSmall || {};

  // Now safely child elements
  const { mp4: mp4L, webm: webmL } = videoL || {};
  const { mp4: mp4S, webm: webmS } = videoS || {};

  if (!imageL?.asset || !imageS?.asset) {
    return null;
  }

  return (
    <div className={cn(styles.root, switchSide && styles.switchSide, textPositionTop && styles.textPositionTop)}>
      <Container>
        <div className={styles.rowMedia}>
          <div className="grid">
            <div className={cn("col-8 col-lg-4", styles.col, styles.colSmall)}>
              <div className={styles.media}>
                <ImageG node={imageS} />
                <Video mp4={mp4S} webm={webmS} />
              </div>
            </div>
            
            <div className={cn("col-lg-8", styles.col, styles.colLarge)}>
              <div className={styles.media}>
                <ImageG node={imageL} />
                <Video mp4={mp4L} webm={webmL} />
              </div>
            </div>
          </div>
        </div>

        <div className={styles.rowText}>
          <div className="grid">
            <div className={cn("col-lg-8", !switchSide && "offset-lg-4", styles.colLarge)}>
              {(title || _rawCopy || button?.url) && (
                <div className={styles.text}>
                  {title && (<h2 className={styles.title}>{title}</h2>)}
                  {_rawCopy && (<div className={cn("entry-content white body-large", styles.copy)}><PortableText blocks={_rawCopy} theme="white" /></div>)}
                  <Button node={button} theme="white" />
                </div>
              )}
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default TwoUpMedia;
